import { useState } from "react";
import { vocabularize } from "src/Common/vocab";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { getImageUrl } from "src/Common/common";

function RoleDropDown({ user, roles, onChange }) {
  const [isDropDownShown, setIsDropDownShown] = useState(false);

  const selectedRole = (user.roles ?? [])[0];

  return (
    <OutsideClickHandler onOutsideClick={() => setIsDropDownShown(false)}>
      <div className="relative">
        <div
          onClick={() => setIsDropDownShown((v) => !v)}
          className="flex items-center justify-between gap-1 px-2 py-2 min-h-[36px] rounded-[6px] border border-[#E5E8F3] cursor-pointer hover:border-[#0058E5]"
        >
          {selectedRole ? (
            <span className="flex justify-center items-center px-2 py-[2px] rounded-[6px] bg-[#EAF3FF] text-center text-[#0058E5] font-OpenSans text-[12px] font-semibold leading-[18px] tracking-[0.12px] capitalize">
              {selectedRole.name}
            </span>
          ) : (
            <span className="font-OpenSansRegular text-[12px] font-[400] text-[#9AA0AE]">Select role</span>
          )}
          <img src={getImageUrl("/images/common/arrow-down.png")} alt="" />
        </div>

        {isDropDownShown && (
          <div className="absolute w-full max-h-[220px] overflow-y-auto px-1 py-1 border border-[#E5E8F3] top-[40px] left-0 z-20 bg-white rounded-[8px] shadow-md">
            {roles.map((role) => (
              <div
                key={role.id}
                onClick={() => {
                  onChange(user, role);
                  setIsDropDownShown(false);
                }}
                className={`w-full flex items-center px-2 py-[6px] rounded-[6px] cursor-pointer hover:bg-[#F8F9FE] ${
                  selectedRole && selectedRole.id === role.id ? "bg-[#F8F9FE]" : ""
                }`}
              >
                <p className="font-OpenSansRegular text-[12px] text-[#1A2332] font-[400] capitalize">{vocabularize(role.name)}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
}

export default RoleDropDown;
